var _path, _path2, _path3, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgK39(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 0.5C30.7696 0.5 39.5 9.23045 39.5 20C39.5 30.7696 30.7696 39.5 20 39.5C9.23045 39.5 0.5 30.7696 0.5 20C0.5 9.23045 9.23045 0.5 20 0.5Z",
    fill: "white",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8333 17.9167C16.6958 17.9167 17.3958 17.2167 17.3958 16.3542C17.3958 15.4917 16.6958 14.7917 15.8333 14.7917C14.9708 14.7917 14.2708 15.4917 14.2708 16.3542C14.2708 17.2167 14.9708 17.9167 15.8333 17.9167ZM13.75 12.7083H26.25C26.825 12.7083 27.2917 13.175 27.2917 13.75V22.4625L23.9552 19.6167C22.924 18.7396 21.3104 18.7396 20.2885 19.6104L12.7083 25.9354V13.75C12.7083 13.175 13.175 12.7083 13.75 12.7083ZM26.25 10.625H13.75C12.0271 10.625 10.625 12.0271 10.625 13.75V26.25C10.625 27.9729 12.0271 29.375 13.75 29.375H26.25C27.9729 29.375 29.375 27.9729 29.375 26.25V13.75C29.375 12.0271 27.9729 10.625 26.25 10.625Z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "url(#paint0_radial_5230_24423)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5230_24423",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 10,
    width: 20,
    height: 20
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8333 17.9167C16.6958 17.9167 17.3958 17.2167 17.3958 16.3542C17.3958 15.4917 16.6958 14.7917 15.8333 14.7917C14.9708 14.7917 14.2708 15.4917 14.2708 16.3542C14.2708 17.2167 14.9708 17.9167 15.8333 17.9167ZM13.75 12.7083H26.25C26.825 12.7083 27.2917 13.175 27.2917 13.75V22.4625L23.9552 19.6167C22.924 18.7396 21.3104 18.7396 20.2885 19.6104L12.7083 25.9354V13.75C12.7083 13.175 13.175 12.7083 13.75 12.7083ZM26.25 10.625H13.75C12.0271 10.625 10.625 12.0271 10.625 13.75V26.25C10.625 27.9729 12.0271 29.375 13.75 29.375H26.25C27.9729 29.375 29.375 27.9729 29.375 26.25V13.75C29.375 12.0271 27.9729 10.625 26.25 10.625Z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5230_24423)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7.5,
    y: 7.5,
    width: 25,
    height: 25,
    fill: "url(#paint1_radial_5230_24423)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_5230_24423",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.5234 34.85) rotate(-90) scale(28.8539 86.1296)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#153C75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B82F6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_5230_24423",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.0312 39.8) rotate(-90) scale(38.4719 114.839)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#153C75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B82F6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgK39);
export default __webpack_public_path__ + "static/media/K39.5ec520267c7e7dee4f98c0cb0c82f32e.svg";
export { ForwardRef as ReactComponent };